import React, { useEffect, useState, useRef } from "react";
// import "./css/solution.details.css";
import CustomButton from "../../Atoms/Buttons/CustomButton";
import usePermissions from "../../../hooks/userPermissions";
import SolutionInfo from "./SolutionInfo";
import Seperator from "../../Atoms/Seperator";
import ProviderInfo from "./ProviderInfo";
import SolutionClassification from "./SolutionClassification";
import { useSolution } from "../../../contexts/SolutionsContext";
import SolutionAgentInfo from "./SolutionAgentInfo";
import { PUBLISHED_TXT, TOAST_CLASSES } from "../../../utils/constants.js";
import ReasonForRejectionSol from "./ReasonForRejectionSol.jsx";

const separatorStyles = {
  border: 0,
  borderTop: "1px solid var(--db-secondary-gray-four)",
  strokeWidth: "O.5px",
  margin: "0",
};

const SolutionDetails = () => {
  const {
    selectedSolution,
    solutionVersions,
    currentSolutionVersion,
    isLoadingVersions,
    publishSolution,
    showToastMessage,
    isApprovingRejecting,
    fetchSolutionsSilently,
    fetchSolutionBFs,
    clearSelectedSol,
    clearSolVersions,
    clearCurrentSolVersion,
    changeSolutionDrawerState,
  } = useSolution();

  const { canSolutionPublish } = usePermissions();

  const reasonBoxRef = useRef(null);

  const [activeSolutionData, setActiveSolutionData] =
    useState(selectedSolution);

  const [enableReasonBoxSol, setEnableReasonBoxSol] = useState(false);

  // Update active solution data when selected solution or versions change
  useEffect(() => {
    if (currentSolutionVersion) {
      setActiveSolutionData(
        solutionVersions?.find(
          (version) => version?.version === currentSolutionVersion
        )
      );
    } else {
      setActiveSolutionData(selectedSolution);
    }
  }, [currentSolutionVersion, solutionVersions, selectedSolution]);

  const clearSolutionDrawerData = async () => {
    clearSelectedSol();
    clearSolVersions();
    clearCurrentSolVersion();

    fetchSolutionsSilently();
    fetchSolutionBFs();

    changeSolutionDrawerState(false);
  };

  const handlePublish = async (e, solutionId, approvalStatus) => {
    e.preventDefault();
    e.stopPropagation();

    if (!selectedSolution?.solution_id) {
      showToastMessage("Solution ID is not available.", TOAST_CLASSES?.ERROR);
      return;
    }

    await publishSolution(solutionId, approvalStatus);
  };

  useEffect(() => {
    if (enableReasonBoxSol && reasonBoxRef?.current) {
      setTimeout(() => {
        reasonBoxRef?.current?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  }, [enableReasonBoxSol]);

  return (
    <article>
      {/* Solution Info Section */}
      <SolutionInfo activeSolutionData={activeSolutionData} />
      <Seperator styles={separatorStyles} />

      {/* Agent Info Section */}
      <SolutionAgentInfo activeSolutionData={activeSolutionData} />
      <Seperator styles={separatorStyles} />

      {/* Provider Info Section */}
      <ProviderInfo activeSolutionData={activeSolutionData} />
      <Seperator styles={separatorStyles} />

      {/* Classification Section */}
      <SolutionClassification activeSolutionData={activeSolutionData} />

      {/* Publish Button */}
      {canSolutionPublish && (
        <section className="d-flex justify-content-end mt-3">
          <CustomButton
            label={`${
              selectedSolution?.approval_status?.toLowerCase() ===
              PUBLISHED_TXT?.toLowerCase()
                ? "Unpublish"
                : "Publish"
            }`}
            onClickFn={async (e) => {
              if (
                selectedSolution?.approval_status?.toLowerCase() !==
                PUBLISHED_TXT?.toLowerCase()
              ) {
                await handlePublish(
                  e,
                  selectedSolution?.solution_id,
                  PUBLISHED_TXT
                );

                await clearSolutionDrawerData();
              } else {
                setEnableReasonBoxSol(true);
              }
            }}
            clsNames={"mas-btn-med mas-secondary-btn-3"}
            disabled={
              isApprovingRejecting ||
              isLoadingVersions ||
              currentSolutionVersion !== solutionVersions?.length ||
              enableReasonBoxSol
            }
          />
        </section>
      )}
      {/* Reason for Rejection for unpublished */}
      {enableReasonBoxSol && (
        <div ref={reasonBoxRef}>
          <ReasonForRejectionSol
            setEnableReasonBoxSol={setEnableReasonBoxSol}
            solutionId={selectedSolution?.solution_id}
            clearSolutionDrawerData={clearSolutionDrawerData}
          />
        </div>
      )}
    </article>
  );
};

export default SolutionDetails;
